<ng-container *ngIf="!showFormView">
  <div *ngIf="emergencyContact?.contactName">
    <div class="mr-small-b">
      <div class="flex flex--middle ms-xxsmall-b">
        <fcom-icon [name]="SvgLibraryIcon.SINGLE_PAX" class="nordic-blue-900-text icon-medium"></fcom-icon>
        <h3 class="ms-xsmall-l medium-type font-body-1" data-hj-suppress>
          <ng-container *ngIf="emergencyContact?.contactName; else emptyName">
            {{ emergencyContact.contactName | titlecase }}
          </ng-container>
        </h3>
      </div>

      <div class="ms-xsmall-l accommodate-icon">
        <div [class.ms-xxsmall-b]="false" data-testid="emergency-phone-number" data-hj-suppress>
          <ng-container>{{ 'MMB.labels.phone.mobile' | finLocalization }}</ng-container
          >:
          <ng-container *ngIf="emergencyContact?.phoneNumberItem?.number; else empty">
            <ng-container *ngIf="emergencyContact?.phoneNumberItem?.countryPrefix">
              +{{ emergencyContact?.phoneNumberItem?.countryPrefix }}</ng-container
            >
            {{ emergencyContact?.phoneNumberItem?.number }}
          </ng-container>
        </div>
      </div>
    </div>

    <div class="align-right">
      <fcom-button
        [size]="ButtonSize.MEDIUM"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'MMB.labels.updateDetails' | finLocalization"
        (clickBtn)="toggleEditView(true)"
      ></fcom-button>
    </div>
  </div>

  <div *ngIf="!emergencyContact?.contactName">
    <div class="flex mr-small-b">
      <div class="ms-xsmall-r">
        <fcom-icon [name]="SvgLibraryIcon.INFO" class="text-red icon-medium"></fcom-icon>
      </div>
      <div>
        <h3 class="medium-type font-body-1 ms-xxsmall-b">
          {{ 'MMB.labels.emergencyContact.notAddedTitle' | finLocalization }}
        </h3>
        <p>{{ 'MMB.labels.emergencyContact.notAddedDescription' | finLocalization }}</p>
      </div>
    </div>
    <div class="align-right">
      <fcom-button
        [size]="ButtonSize.MEDIUM"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'MMB.labels.addDetails' | finLocalization"
        (clickBtn)="toggleEditView(true)"
      ></fcom-button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showFormView">
  <form
    [formGroup]="contactForm"
    [class.disabled]="contactForm.disabled"
    [finFormErrorFocus]="contactForm"
    (ngSubmit)="updateContact()"
  >
    <fcom-text-input
      *ngFor="let inputName of ['firstName', 'lastName']"
      [attr.data-testid]="'form-field-' + inputName"
      class="input-name block ms-small-t"
      (change)="stripSpaces(inputName)"
      [translationPrefix]="'paxDetails.fields.' + inputName"
      [id]="inputName"
      [parentForm]="contactForm"
      [controlName]="inputName"
      [tooltipHeading]="'paxDetails.fields.' + inputName + '.tooltipHeading' | finLocalization"
      [tooltipContent]="'paxDetails.fields.' + inputName + '.tooltipContent' | finLocalization"
      [required]="true"
    >
    </fcom-text-input>

    <fin-form-group
      class="block field wd-phone pr-xsmall-b"
      [group]="contactForm.get('phone')"
      [translationPrefix]="'paxDetails.fields'"
      [names]="['phonePrefix', 'phoneNumber']"
      [showOnlyGroupLevelErrors]="true"
    >
      <div class="phone-wrapper flex">
        <fin-select-input
          data-testid="form-field-phonePrefix"
          class="input-phone flex-1 flex--basis0 ms-small-t"
          [controlName]="'phonePrefix'"
          [translationPrefix]="'paxDetails.fields.phonePrefix'"
          [parentForm]="contactForm.get('phone')"
          [displayMargin]="false"
          [id]="'phonePrefix'"
          [options]="phonePrefixes$ | async"
          [required]="true"
          [selectLabelTranslationKey]="'paxDetails.fields.phonePrefix.placeholder'"
        >
        </fin-select-input>
        <fcom-text-input
          finPhoneNumberMask
          class="flex-1 flex--basis0 ms-small-t"
          data-testid="form-field-phoneNumber"
          [controlName]="'phoneNumber'"
          [translationPrefix]="'paxDetails.fields.phoneNumber'"
          [parentForm]="contactForm.get('phone')"
          [displayMargin]="false"
          [required]="true"
          [id]="'phoneNumber'"
          [placeHolder]="'paxDetails.fields.phoneNumber.placeholder'"
        >
        </fcom-text-input>
      </div>
    </fin-form-group>

    <div class="align-right">
      <fcom-button
        data-testid="emergency-contact-cancel-button"
        [disabled]="updatingContacts"
        [size]="ButtonSize.MEDIUM"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'actions.cancel' | finLocalization"
        (clickBtn)="toggleEditView(false)"
      ></fcom-button>
      <fcom-button
        class="pr-xsmall-l"
        data-testid="emergency-contact-submit-button"
        [loading]="updatingContacts"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [icon]="updatingContacts ? { name: SvgLibraryIcon.TRANSFER_LOADER, position: IconPosition.RIGHT } : null"
        [type]="ButtonType.SUBMIT"
        [size]="ButtonSize.MEDIUM"
        [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        [text]="'MMB.labels.saveDetails' | finLocalization"
      ></fcom-button>
    </div>
  </form>
</ng-container>

<ng-template #emptyName>
  {{ 'MMB.labels.name' | finLocalization }}: <ng-container *ngTemplateOutlet="empty"></ng-container>
</ng-template>

<ng-template #empty>
  <span aria-hidden="true">-</span>
  <span class="is-vishidden">{{ 'MMB.ariaLabels.infoMissing' | finLocalization }}</span>
</ng-template>
